import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

const EXTERNAL = ["/area-clienti", "/portale-clienti", "/area-riservata", "/area-broker", "/area-compagnia", "/inserisci-offerta", "/offerta", "/richiedi-preventivo", "/preventivo/", "/sign/", "/revisione/", "/bollo/"];
const KEY = "gdpr_cookie_consent";

// Banner cookie per utenti esterni (portale professionisti e area clienti).
export const CookieBanner = () => {
  const { pathname } = useLocation();
  const [text, setText] = useState("");
  const [done, setDone] = useState(() => !!localStorage.getItem(KEY));
  const show = !done && EXTERNAL.some((p) => pathname.startsWith(p));

  useEffect(() => {
    if (show && !text) api.get("/public/gdpr/cookie").then(({ data }) => setText(data.text)).catch(() => setText(" "));
  }, [show, text]);

  if (!show || !text) return null;

  const choose = (choice) => {
    let vid = localStorage.getItem("gdpr_visitor_id");
    if (!vid) { vid = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()); localStorage.setItem("gdpr_visitor_id", vid); }
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    api.post("/public/gdpr/cookie-consent", { visitor_id: vid, choice, path: pathname }).catch(() => {});
    setDone(true);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-slate-900 text-white rounded-xl shadow-2xl p-4 flex flex-col sm:flex-row gap-3 sm:items-center">
        <Cookie className="h-6 w-6 text-amber-300 shrink-0" />
        <p className="text-xs sm:text-sm text-slate-200 flex-1" data-testid="cookie-banner-text">{text}</p>
        <div className="flex gap-2 shrink-0">
          <Button size="sm" variant="outline" className="bg-transparent text-white border-slate-500 hover:bg-slate-800 hover:text-white" onClick={() => choose("necessary")} data-testid="cookie-banner-necessary">Solo necessari</Button>
          <Button size="sm" className="bg-amber-400 text-slate-900 hover:bg-amber-300" onClick={() => choose("all")} data-testid="cookie-banner-accept">Accetta tutti</Button>
        </div>
      </div>
    </div>
  );
};
